
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Paul L., 86, verstorben am 2. April 2020</b>
    <br />
    <br />
    <i>Seine Frau sagt:</i>
    <br />
    <p>
  «Es ist unfassbar, dass er nicht mehr da ist – wir hatten noch so viele Pläne
  und Projekte. Er war topfit und voller Lebensfreude.
    </p>
    <p>
  Mein Mann ist mit unserem Sohn für drei Tage nach Ischgl zum Skifahren
  gereist. Die beiden sind jeweils nach dem Skifahren ins Hotel gegangen – ohne
  Après-Ski. Als Ischgl am 12. März endlich kommuniziert hatte, dass es
  gravierende Probleme mit Corona gebe, sind sie unverzüglich nach Hause
  gereist. Bereits da fühlte sich der Sohn nicht ganz wohl. Wenige Tage später
  waren auch wir beide positiv.
    </p>
    <p>
  Es ging meinem Mann bald immer schlechter. Hohes Fieber, Schmerzen und
  Erschöpfung haben ihn ausgelaugt. Aber wir haben keinen Moment ans Sterben
  gedacht.
    </p>
    <p>
  In einem lokalen Spital haben sie ihn nur kurz untersucht und wieder nach
  Hause geschickt. Einen Tag später brachte ihn mein Sohn in eine Privatklinik.
  Dort fragten sie ihn schon nach zwei Tagen, ob er auf die Intensivstation an
  die Beatmungsmaschine möchte. Die Ärzte machten ihm Hoffnung, dass er es im
  künstlichen Koma schaffen würde, das Virus zu bekämpfen. Er war überzeugt,
  dass er die Infektion besiegen und wieder nach Hause kommen würde. Kurz bevor
  er starb, erlaubte man mir und meinen vier Kindern, uns von ihm zu
  verabschieden.
    </p>
    <p>
  Wenn ich den Leuten von meinem Mann erzähle, geht es ihnen nahe. Vielleicht
  werden die Menschen vorsichtiger, wenn sie von den Toten und unserem Schicksal
  hören. Wir beteiligen uns an der Sammelklage gegen Ischgl. Es soll jemand
  Verantwortung übernehmen, auch wenn es an unserem Leid nichts ändert.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;